import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="bg-gray-900 py-20 px-4 text-center relative overflow-hidden" data-id="element-117">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-118"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-119">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-8 leading-tight" data-id="element-120">
          No dejes pasar esta oportunidad de <br data-id="element-121" />
          <span className="text-yellow-400" data-id="element-122">
            transformar el tiempo libre
          </span>{' '}
          de tus hijos
        </h2>
        <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-123">
          La oferta especial y los bonos gratuitos desaparecerán pronto. ¡Actúa
          ahora!
        </p>
        <CTAButton text="¡QUIERO APROVECHAR LA OFERTA!" href="https://recursoseducapro.shop/cart/47652553720046:1" className="shadow-yellow-500/20" data-id="element-124" />
      </div>
    </section>;
}